<script lang="ts">
  import MainMenuV2 from "$lib/components/MainMenuV2.svelte";
</script>

<MainMenuV2 />
